<template>
  <router-link
    :to="`/course/${element.id}/lessons`"
    class="n-course-preview"
  >
    <!-- Картинка курса и кнопка лайка -->
    <div class="n-course-preview__img">
      <LikeButton
        class="n-course-preview__like"
        :element="element"
        @toggleFavoriteStatus="$emit('toggleFavoriteStatus')"
      />

      <AppImage
        v-if="element.img"

        :image="`https://navigator-backend.eurekacenter.ru/api/download/avatar/course${element.img}`"
      />
    </div>

    <!-- Блок лектора / автора -->
    <div
      class="flex n-course-preview__icon-text n-course-preview__coach"
      v-if="element.coach"
    >
      <div class="n-avatar" v-if="element.coach.personAvatar">
        <AppImage :image="`https://navigator-backend.eurekacenter.ru/api/download/avatar/user/${element.coach.personAvatar}`" />
      </div>
      <AppIcon v-else icon="circle-user-icon" />

      <div class="n-course-preview__name flex">
        <span v-if="element.coach.firstname">{{ element.coach.firstname }}</span>
        <span v-if="element.coach.secname">{{ element.coach.secname }}</span>
        <span v-if="element.coach.lastname">{{ element.coach.lastname }}</span>
      </div>
    </div>

    <!-- Название курса -->
    <AppTitle mode="h4" class="n-course-preview__title">
      <template v-slot:title>{{ element.title }}</template>
    </AppTitle>

    <!-- ИСПРАВЛЕНО: Безопасное превью-описание с новым БЭМ-классом -->
    <div class="n-course-preview__description">
      {{ stripHtml(element.description) }}
    </div>

    <!-- Нижняя панель со статистикой (звезды и уроки) -->
    <div class="flex flex__sb n-course-preview__info">
      <div class="flex n-course-preview__icon-text">
        <AppIcon icon="star-icon" />
        <span>{{ element.stars }}</span>
      </div>

      <div class="flex n-course-preview__icon-text">
        <AppIcon icon="book-icon" />
        <span>{{ t("lessons.quantity") }}: {{ element.lessonsQuantity }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
import { t } from "@/utils/translate";

import AppIcon from "@/elements/AppIcon";
import AppImage from "@/elements/AppImage";
import AppTitle from "@/elements/AppTitle.vue";
import LikeButton from "@/elements/LikeButton.vue";

export default {
  emits: ["toggleFavoriteStatus"],
  components: { AppImage, AppIcon, AppTitle, LikeButton },
  props: {
    element: {
      type: Object,
      required: true,
    },
    inFavorite: {
      type: Boolean,
      required: false,
    },
    },
    methods: {
        stripHtml(htmlString) {
            if (!htmlString) return '';
            // Регулярное выражение аккуратно вырезает <p>, <ul>, <li>, <strong>
            // и превращает контент в чистую строку для безопасной обрезки через CSS
            return htmlString.replace(/<\/?[^>]+(>|$)/g, " ").trim();
        }
    },
    setup() {

        return {
      t,
    };
  },
};
</script>

<style lang="scss">
 // =========================================================================
 // ПОЛНЫЙ БЛОК СТИЛЕЙ С ПОЛНЫМ НАЗВАНИЕМ И ДИНАМИЧЕСКИМ ОПИСАНИЕМ
 // =========================================================================
 .n-course-preview {
  min-width: 0 !important;
   width: 100% !important;

   padding: 24px;
   border: none !important;
   background-color: #ffffff;
   display: grid;



   // Современная мягкая тень
   box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04), 0 1px 2px rgba(15, 23, 42, 0.02) !important;

   display: grid;
   grid-template-columns: 1fr;
   grid-gap: 16px;

   // ИСПРАВЛЕНО: Название теперь забирает сколько нужно (max-content),
   // а Описание (1fr) динамически занимает ВСЁ свободное место до самого низа.
   grid-template-rows: 200px 32px max-content 1fr max-content;

   border-radius: 16px;
   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
   cursor: pointer;
   color: #334155;
   text-decoration: none;
   height: 100%; // Все карточки в каталоге строго одной высоты

   p {
     align-items: flex-start;
   }

   // --- БЛОК АВТОРА / ЛЕКТОРА ---
   &__coach {
     margin: 0;
     display: flex;
     align-items: center;
     gap: 10px;
     height: 32px;
     overflow: hidden;

     span {
       margin: 0;
     }
   }

   // Круглая мини-аватарка
   .n-avatar {
     width: 28px;
     height: 28px;
     border-radius: 50%;
     overflow: hidden;
     flex-shrink: 0;
     box-shadow: 0 0 0 2px #f1f5f9;

     img {
       width: 100%;
       height: 100%;
       object-fit: cover;
     }
   }

   svg {
     flex-shrink: 0;
     color: #94a3b8;
   }

   // ФИО лектора
   &__name {
     font-size: 13px !important;
     font-weight: 500 !important;
     color: #64748b !important;
     line-height: 1;
     letter-spacing: -0.01em;
     display: block;

     span {
       margin-right: 4px;
     }
   }


&__title {
    text-align: left;
    margin: 0;
    height: auto;

    // ДОБАВИТЬ ЭТИ ТРИ СТРОКИ ЗДЕСЬ:
    width: 100% !important;
    min-width: 0 !important;
    overflow: hidden !important;

    :deep(*) {
      font-size: 15.5px !important;
      font-weight: 700 !important;
      line-height: 1.4 !important;
      color: #0f172a !important;
      margin: 0;

      display: block !important;
      white-space: normal !important; // Разрешаем стандартный перенос слов

      // Форсированный перенос, если бэкенд отдал текст без пробелов
      word-break: break-word !important;
      overflow-wrap: break-word !important;
    }
  }

   // --- ИСПРАВЛЕНО: УМНОЕ ОБРЕЗАНИЕ ПРЕВЬЮ-ОПИСАНИЯ ---
   &__description {
     font-size: 13.5px !important;
     line-height: 1.55 !important;
     color: #64748b !important;
     margin: 0;

     // Блок занимает всю оставшуюся высоту ячейки 1fr
     height: 100%;

     // Магия многострочного скрытия:
     display: -webkit-box;
     // Автоматически показывает 2 или 3 строки в зависимости от того,
     // сколько места «отъел» длинный заголовок сверху
     -webkit-line-clamp: 3;
     -webkit-box-orient: vertical;
     overflow: hidden;
     text-overflow: ellipsis;
     word-break: break-word;
   }

   // --- ИЗОБРАЖЕНИЕ КУРСА ---
   &__img {
     width: 100%;
     position: relative;
     border-radius: 12px;
     overflow: hidden;
     height: 200px;
     background-image: $gradient;

     .app-image img {
       transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
       width: 100%;
       height: 100%;
       object-fit: cover;
     }
   }

   // Кнопка-сердечко (лайк)
   &__like {
     position: absolute;
     top: 14px;
     right: 14px;
     width: 36px;
     height: 36px;
     background-color: #ffffff;
     display: flex;
     justify-content: center;
     align-items: center;
     border-radius: 50%;
     z-index: 1;
     transition: all 0.2s ease;
     box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);

     svg {
       stroke: #f77587 !important;
       fill: transparent;
       width: 18px;
       height: 18px;
     }

     &:hover {
       background-color: #f77587;
       svg { stroke: #ffffff !important; }
     }
   }

   // Статистика (звезды и занятия)
   &__icon-text {
     font-size: 13.5px !important;
     font-weight: 600 !important;
     color: #475569 !important;
     display: flex;
     align-items: center;

     svg {
       margin-right: 6px;
       width: 16px;
       height: 16px;
     }
   }

   // --- ПЛАШКА СТАТИСТИКИ ВНИЗУ ---
   &__info {
     color: $text;
     padding-top: 16px;
     border-top: 1px solid #f1f5f9 !important;

     svg {
       stroke: #64748b;
     }
   }

   // --- ЭФФЕКТЫ ПРИ НАВЕДЕНИИ ---
   &:hover {
     background-color: #ffffff;
     box-shadow: 0 20px 25px -5px rgba(15, 23, 42, 0.08), 0 8px 10px -6px rgba(15, 23, 42, 0.08) !important;
     transform: translateY(-4px);

     .app-image img {
       transform: scale(1.03);
     }
   }

   // --- АДАПТИВНОСТЬ ПОД МОБИЛКИ ---
   @media (max-width: 768px) {
     padding: 16px;
     grid-template-rows: 160px 32px max-content 1fr max-content;
     grid-gap: 14px;

     &__title {
       :deep(*) { font-size: 15px !important; }
     }
   }
 }



</style>


}
